import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LatestFooterComponent } from 'src/app/shared/components/latest-footer/latest-footer.component';
import { TopHeaderComponent } from 'src/app/shared/components/latest-header/top-header/top-header.component';
import { LogOutModaleDayComponent } from 'src/app/shared/components/log-out-modale/log-out-modale.component';
import { MainWrapperComponent } from 'src/app/core/components/main-wrapper/main-wrapper.component';
import { StocksAndEtfsSearchComponent } from 'src/app/shared/components/primary-header/stocks-and-etfs-search/stocks-and-etfs-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LazyLoadImageDirective } from 'src/app/shared/directives/lazy-load-image/lazy-load-image.directive';
import { TimeAgoPipe } from 'src/app/shared/pipes/time-ago.pipe';
import { BannerTradingAnnouncementComponent } from 'src/app/shared/components/banners/banner-trading-announcement/banner-trading-announcement.component';
import { SidebarMenuComponent } from 'src/app/shared/components/latest-header/sidebar-menu/sidebar-menu.component';

@NgModule({
   declarations: [
      MainWrapperComponent,
      LatestFooterComponent,
      LogOutModaleDayComponent,
      StocksAndEtfsSearchComponent,
      LazyLoadImageDirective,
      BannerTradingAnnouncementComponent,
   ],
   imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      NgbModule,
      RouterModule,
      NgxSkeletonLoaderModule,
      TopHeaderComponent,
      TimeAgoPipe,
      SidebarMenuComponent,
   ],
   exports: [
      MainWrapperComponent,
      LogOutModaleDayComponent,
      LazyLoadImageDirective,
      StocksAndEtfsSearchComponent,
      TimeAgoPipe,
   ]
})
export class MainWrapperModule {}
